import styled from 'styled-components';

const style = (Component, styles = '', attrs = {}) => styled(Component).attrs(attrs)`${styles}`;

export { style };
